<template>
  <div>
    <div class="banner">
      <div class="banner-content">
        <img class="img-fluid" src="../assets/images/banner/health_banner.jpg" alt="banner" />
        <div class="banner-text">
          <h1>影音雜誌專區</h1>
          <div class="banner-text-line"></div>
          <span>Journals&Videos</span>
        </div>
      </div>
    </div>
    <!-- 上方切換選單 -->
    <div class="contentContainer-noMove" :style="{backgroundImage: 'url(' + BG + ')' }">
      <div class="content">
        <div class="d-flex justify-content-center">
        </div>
        <div class="tab-content" id="nav-tabContent">
          <div
            class="tab-pane fade show active"
            id="list-magazine"
            role="tabpanel"
            aria-labelledby="list-magazine-list"
            v-if="isPlan"
          >
            <div class="content-title">
              <h2>{{ planTitle }}</h2>
              <div class="bread">
                <router-link to="/">
                  <i class="fas fa-home fa-lg"></i>
                </router-link>
                <span>></span>
                影音雜誌專區
              </div>
            </div>
            <transition-group mode="out-in">
              <div v-if="title === '電子會刊'" key="transition1">
                <div v-if="detail.Id">
                  <div class="content-textBox">
                    <div class="contribution-img">
                      <img
                        v-if="detail.Picture"
                        :src="detail.Picture"
                        :alt="detail.Title"
                      />
                      <img
                        v-else
                        src="@/assets/images/magazine_default.jpg"
                        :alt="detail.Title"
                      />
                    </div>
                    <div class="contribution-content">
                      <div class="contribution-content-top">
                        <div class="contribution-content-table" v-if="detail.DocumentFile">
                          <div class="contribution-content-info">
                            <div>
                              <img src="../assets/images/icon/download_03.png" alt />
                            </div>下載檔案
                          </div>
                          <div class="contribution-content-detail">
                            <a href="#" @click.prevent="download(detail.DocumentFile)">
                              <img src="../assets/images/icon/pdf.svg" alt="pdf" />
                              下載檔案
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="contribution-content-text" v-html="detail.Introduction">

                      </div>
                    </div>
                  </div>
                  <div class="contact-back">
                    <a href="#" @click.prevent="toList">
                      回列表
                      <img src="../assets/images/icon/back_icon.png" alt="回列表" />
                    </a>
                  </div>
                </div>
              </div>
            </transition-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import MagazineApi from '@/assets/api/magazine';
import Common from '@/common';
import BG from '../assets/images/index_bg_big.png';

export default {
  name: 'Plan',
  data() {
    return {
      BG,
      title: '電子會刊',
      planTitle: '電子會刊',
      isPlan: true,
      fileType: '',
      Submission: false,
      listTitle: [
        {
          titleZh: '電子會刊',
          titleEn: 'Magazine',
        },
        {
          titleZh: '影音專區',
          titleEn: 'Video',
        },
      ],
      detail: {
      },
      admissionDetail: {
      },
      myFile: [],
      fileName: '',
      fullFileName: '',
      formData: {
        Name: '',
        Mobile: '',
        Email: '',
        Affiliation: '',
        Position: '',
        submitTitle: '',
      },
    };
  },
  methods: {
    getDetail(id) {
      const vm = this;
      MagazineApi.getMagazineDetail(id).then((res) => {
        if (res.status === 200) {
          if (vm.$route.params.admissionId) {
            vm.admissionDetail = res.data.Data;
            vm.planTitle = vm.admissionDetail.Title;
            // console.log('錄取名單', res);
          } else if (vm.$route.params.planId) {
            vm.detail = res.data.Data;
            vm.planTitle = vm.detail.Title;
            // console.log('投稿', res);
          }
        }
      });
    },
    setSupervisory(index) {
      const vm = this;
      $('.btn-supervisory').removeClass('active');
      // eslint-disable-next-line no-restricted-globals
      $(event.target).addClass('active');
      // eslint-disable-next-line no-restricted-globals
      // console.log(event.target.getAttribute('data-id'), index, event.target);
      vm.nowIndex = index;
    },
    setPage(text) {
      const vm = this;
      // vm.planTitle = text;
      // vm.title = text;
      if (text === '專題投稿' || text === '錄取名單') {
        vm.$store.commit('PLANTITLE', text);
        vm.$router.push('/plan');
      }
    },
    downloadFunction(url, params = {}) {
      const uA = window.navigator.userAgent;
      const isIE = /msie\s|trident\/|edge\//i.test(uA)
        && !!(
          'uniqueID' in document
          || 'documentMode' in document
          || 'ActiveXObject' in window
          || 'MSInputMethodContext' in window
        );

      let Type;
      if (params.type === 'paf' || params.type === 'PDF') {
        Type = 'application/pdf';
      } else if (params.type === 'doc') {
        Type = 'application/msword';
      } else {
        Type = `video/${params.type}`;
      }
      this.$http
        .get(url, { responseType: 'blob' })
        .then(({ data }) => {
          const blob = new Blob([data], { type: Type });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `TADHfile.${params.type}`;

          if (isIE) {
            navigator.msSaveBlob(new Blob([data]), `TADHfile.${params.type}`);
          } else {
            link.click();
          }
        })
        .catch((err) => {
          // console.log('錯誤', err);
        });
      return true;
    },
    download(url) {
      const vm = this;
      const Type = url.split('/').pop().split('.').pop();
      vm.downloadFunction(url, { type: Type });
    },
    getParamsId(name) {
      const results = new RegExp(`[?&]${name}=([^&#]*)`).exec(
        window.location.href,
      );
      if (results == null) {
        return null;
      }
      return decodeURI(results[1]) || 0;
    },
    openSubmission() {
      const vm = this;
      if (vm.Submission !== true) {
        vm.Submission = true;
      }
    },
    toList() {
      const vm = this;
      vm.$router.push('/healthEducation');
    },
    getDocumentID(id) {
      const vm = this;
      vm.$router.push(`/plan/admissionId/${id}`);
    },
  },
  created() {
    // $('#collapseOne').collapse('hide');
    const vm = this;
    if (vm.$route.params.admissionId) {
      vm.getDetail(vm.$route.params.admissionId);
    } else if (vm.$route.params.planId) {
      vm.getDetail(vm.$route.params.planId);
    }
    // const UrlString = window.location.href;
    // const Url = new URL(UrlString);
    // const Id = vm.getParamsId('Id');
    // const admissionID = vm.$route.params.admissionId; // vm.getParamsId('admissionId');
    // vm.submissionId = vm.$route.params.PlanId; // vm.getParamsId('Id');
    vm.guid = Common.generateUUID();
    // if (window.location.href.indexOf('planId') !== -1) {
    //   // if (process.env.NODE_ENV === 'production') {
    //   //   // eslint-disable-next-line no-undef
    //   //   API.getSubmissionDetail({ Id }).then((res) => {
    //   //     if (res.Ok) {
    //   //       vm.Detail = res.Data;
    //   //     }
    //   //   });
    //   // } else {
    //   vm.Detail = {
    //     Id: '5d5d4a9b-f19a-474e-90c3-c8ee87c0d359',
    //     Title: '艾利根論文獎甄選活動!!',
    //     // eslint-disable-next-line global-require
    //     Image: require('@/assets/images/magazinepic2.jpg'),
    //     StartOn: '2019-07-11T00:00:00',
    //     EndOn: '2019-08-17T00:00:00',
    //     DocumentFile:
    //       'https://retinasociety.blob.core.windows.net/submission/eeb70bfb-ea96-4fb9-8957-59ec9131cf68/9a66c81ffdd24878b9821af506da5f22.doc',
    //     Content: `   <p>親愛的會員您好:</p>
    //           <p>
    //             今年的第八屆TRS年會將會與第十五屆世界眼炎醫學會年會「15th International Ocular Inflammation Society (IOIS) Congress」假高雄展覽館合辦。其中IOIS會期為108年11月13日至16日(星期三至星期六)，而
    //             <strong>TRS年會將會於民國108年11月16日(星期六)舉辦</strong>，年會中包含一Free Paper Presentation時段，題目不拘，預定講者八名。另今年第四屆台日聯合會將會同日本視網膜醫學會年會(108年12月6日至8日)在日本長崎舉辦，同往例包含Rapid Fire單元，題目不拘，預定講者八名。
    //           </p>
    //           <p>本會現針對第八屆視網膜醫學會年會Free Paper及第四屆台日聯合會Rapid Fire舉辦聯合徵稿活動，在此敬邀各位會員踴躍投稿。投稿注意事項如下</p>
    //           <ul>
    //             <li>(一) 投稿台日Rapid-Fire並獲選報告者，將依據往例日方提供報名費及住宿，本會提供新台幣一萬元整交通補助。</li>
    //             <li>(二) 第一階段評選: 無論投稿Free Paper或Rapid Fire，Abstract篩選獲選者，需於108年8月4日本年度第二次Retina club中報告，並由本會學術委員會選出最終適合報告之論文。</li>
    //             <li>
    //               (三) 今年在諾華公司贊助下，設立「影像與疾病趨勢專題」研究獎，學術委員會及評審將就108年8月4日之預報內容評審，選出nAMD研究組兩名DR/DME研究組兩名，共計四名得獎者，
    //               <span
    //                 style="backgroundColor:#ff0;"
    //               >各頒予NTD 20,000現金</span>。申請人須為該論文之第一作者，且該研究需為台灣本土之研究資料，尚未於其他處發表。評選內容將同時依據摘要與上台報告時呈現之影像及內容評之。
    //             </li>
    //             <li>
    //               (四) 敬請各位會員於
    //               <strong>6月20日</strong>前填好abstract form (如附件)電郵交付TRS辦公室，投稿時務必註明想在台日報告、想在IOIS報告、或均可。
    //             </li>
    //           </ul>
    //           <p>另本會今年協辦第十五屆IOIS Congress，秘書處在此亦鼓勵各位會員及所屬住院醫師踴躍報名參加及投稿，其中Abstract投稿現已開放，截止日期為6月1日。</p>
    //           <p>
    //             相關投稿事項請至IOIS網站:
    //             <a
    //               href="https://www.iois.info/page.php?edi_id=1463"
    //             >https://www.iois.info/page.php?edi_id=1463</a>。本會為鼓勵住院醫師多參與此次會議，凡住院醫師投稿IOIS獲選者，學會即補助會議報名費NTD 3,000元整。(本國住院醫師報名費早鳥價150 EURO)
    //           </p>
    //           <p>這些會議均是千載難逢與國際專家交流的好機會，歡迎大家多多踴躍參與投稿，千萬不要錯過囉!!</p>
    //           <p>中華民國視網膜醫學會 陳世真 理事長</p>
    //           <p>第八屆會員大會暨學術演講會/第15屆IOIS醫學會年會</p>
    //           <p>許淑娟 會長 敬邀</p>`,
    //   };
    //   vm.planTitle = vm.Detail.Title;
    //   // }
    // } else if (window.location.href.indexOf('admissionId') !== -1) {
    //   vm.admissionDetail = {
    //     Id: '5d5d4a9b-f19a-474e-90c3-c8ee87c0d359',
    //     Title: '艾利根論文獎甄選活動!!',
    //     // eslint-disable-next-line global-require
    //     Image: require('@/assets/images/magazinepic2.jpg'),
    //     StartOn: '2019-07-11T00:00:00',
    //     EndOn: '2019-08-17T00:00:00',
    //     DocumentFile:
    //       'https://retinasociety.blob.core.windows.net/submission/eeb70bfb-ea96-4fb9-8957-59ec9131cf68/9a66c81ffdd24878b9821af506da5f22.doc',
    //     Content: `   <p>親愛的會員您好:</p>
    //           <p>
    //             今年的第八屆TRS年會將會與第十五屆世界眼炎醫學會年會「15th International Ocular Inflammation Society (IOIS) Congress」假高雄展覽館合辦。其中IOIS會期為108年11月13日至16日(星期三至星期六)，而
    //             <strong>TRS年會將會於民國108年11月16日(星期六)舉辦</strong>，年會中包含一Free Paper Presentation時段，題目不拘，預定講者八名。另今年第四屆台日聯合會將會同日本視網膜醫學會年會(108年12月6日至8日)在日本長崎舉辦，同往例包含Rapid Fire單元，題目不拘，預定講者八名。
    //           </p>
    //           <p>本會現針對第八屆視網膜醫學會年會Free Paper及第四屆台日聯合會Rapid Fire舉辦聯合徵稿活動，在此敬邀各位會員踴躍投稿。投稿注意事項如下</p>
    //           <ul>
    //             <li>(一) 投稿台日Rapid-Fire並獲選報告者，將依據往例日方提供報名費及住宿，本會提供新台幣一萬元整交通補助。</li>
    //             <li>(二) 第一階段評選: 無論投稿Free Paper或Rapid Fire，Abstract篩選獲選者，需於108年8月4日本年度第二次Retina club中報告，並由本會學術委員會選出最終適合報告之論文。</li>
    //             <li>
    //               (三) 今年在諾華公司贊助下，設立「影像與疾病趨勢專題」研究獎，學術委員會及評審將就108年8月4日之預報內容評審，選出nAMD研究組兩名DR/DME研究組兩名，共計四名得獎者，
    //               <span
    //                 style="backgroundColor:#ff0;"
    //               >各頒予NTD 20,000現金</span>。申請人須為該論文之第一作者，且該研究需為台灣本土之研究資料，尚未於其他處發表。評選內容將同時依據摘要與上台報告時呈現之影像及內容評之。
    //             </li>
    //             <li>
    //               (四) 敬請各位會員於
    //               <strong>6月20日</strong>前填好abstract form (如附件)電郵交付TRS辦公室，投稿時務必註明想在台日報告、想在IOIS報告、或均可。
    //             </li>
    //           </ul>
    //           <p>另本會今年協辦第十五屆IOIS Congress，秘書處在此亦鼓勵各位會員及所屬住院醫師踴躍報名參加及投稿，其中Abstract投稿現已開放，截止日期為6月1日。</p>
    //           <p>
    //             相關投稿事項請至IOIS網站:
    //             <a
    //               href="https://www.iois.info/page.php?edi_id=1463"
    //             >https://www.iois.info/page.php?edi_id=1463</a>。本會為鼓勵住院醫師多參與此次會議，凡住院醫師投稿IOIS獲選者，學會即補助會議報名費NTD 3,000元整。(本國住院醫師報名費早鳥價150 EURO)
    //           </p>
    //           <p>這些會議均是千載難逢與國際專家交流的好機會，歡迎大家多多踴躍參與投稿，千萬不要錯過囉!!</p>
    //           <p>中華民國視網膜醫學會 陳世真 理事長</p>
    //           <p>第八屆會員大會暨學術演講會/第15屆IOIS醫學會年會</p>
    //           <p>許淑娟 會長 敬邀</p>`,
    //   };
    //   vm.planTitle = vm.admissionDetail.Title;
    // }

    // // if (vm.getParamsId('page') === 'admission') {
    // //   vm.title = '錄取名單';
    // //   vm.planTitle = vm.title;
    // // }
    if (window.location.href.indexOf('admissionId') !== -1) {
      vm.title = '錄取名單';
    }
  },
  computed: {
    fromPath() {
      return this.$store.getters.from;
    },
  },
};
</script>

<style lang="scss">
.magazine-wrap {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  @media (max-width: 420px) {
    justify-content: center;
  }
  &:after {
    content: "";
    flex: 0 0 30%;
    width: 33.33333%;
    max-width: 325px;
  }
}
.submission_box .input_span label {
  display: block;
  padding: 5px 24px;
  background-color: #f68e56;
  color: #fff;
  // border-radius: 5px;
  cursor: pointer;
}
.submission_box .input_span .note {
  letter-spacing: 2px;
  padding: 5.5px 0;
}
.submission_box .input_span input[type="file"] {
  display: none;
}
.file_name {
  display: flex;
  align-items: center;
  flex: 1;
}
.file_name input {
  flex: 1;
  /* margin-right: 10px; */
}
.file_name .delete {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.file_name .delete span:nth-child(1) {
  color: #f00;
  font-weight: 600;
  padding: 0 10px;
  font-size: 1.5rem;
  width: unset;
  text-align: unset;
  margin-right: unset;
}
.file_name .delete span:nth-child(2) {
  font-weight: 600;
  display: flex;
  align-items: center;
  cursor: pointer;
  width: unset;
  text-align: unset;
  margin-right: unset;
}

.fileArea {
  display: flex;
  align-items: center;
  width: 100%;

  label {
    margin-bottom: 0;
  }
}
</style>
